import { render, staticRenderFns } from "./scdcdjcf2.vue?vue&type=template&id=82acc5c2&scoped=true&"
import script from "./scdcdjcf2.vue?vue&type=script&lang=js&"
export * from "./scdcdjcf2.vue?vue&type=script&lang=js&"
import style0 from "./scdcdjcf2.vue?vue&type=style&index=0&id=82acc5c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82acc5c2",
  null
  
)

export default component.exports